import React, { useState } from 'react';
import styles from './CustomToggle.module.css';

const CustomToggle = (props) => {
    const {
       labels,
       selectedToggle,
       handleToggle
    } = props;

    const [selected, setSelected] = useState(selectedToggle ?? labels[0].value);

    const handleChange = (value) => {
        setSelected(value);
        handleToggle(value);
    }

    return (
        <div className={styles.Toggle}>
            {labels.map((label) => 
                <React.Fragment key={label.value}>
                    <input key={label.value} type="radio" name="customToggle" value={label.value}
                        checked={selected===label.value}
                        onChange={handleChange}
                    ></input>
                    <label key={`label-${label.value}`} onClick={()=>handleChange(label.value)}> {label.name}</label>
                </React.Fragment>
            )}
        </div>
    );
};

export default CustomToggle;
